import React, { useState } from "react";

import "../css/LynxStyle.css";

const TYPES = {
  social: {
    title: "The Social Butterfly Lynx",
    emoji: "🦋",
    desc: "You light up every room and never miss a chance to connect. Your friends can always count on you to turn a quiet night into a party!",
  },
  chill: {
    title: "The Chill Lynx",
    emoji: "😎",
    desc: "Calm, cool and collected. You don't sweat the small stuff and you always know how to relax and enjoy the moment.",
  },
  adventure: {
    title: "The Adventure Lynx",
    emoji: "🌍",
    desc: "You're always chasing the next thrill! New places, new experiences — sitting still just isn't your style.",
  },
  mastermind: {
    title: "The Mastermind Lynx",
    emoji: "🧠",
    desc: "Strategic, sharp and always three steps ahead. You'd rather plan the perfect move than wing it.",
  },
};

const QUESTIONS = [
  {
    question: "It's Saturday night, what are you doing?",
    options: [
      { text: "Out with a big group of friends", type: "social" },
      { text: "Relaxing at home with a movie", type: "chill" },
      { text: "Trying out a new spot in town", type: "adventure" },
      { text: "Planning next week already", type: "mastermind" },
    ],
  },
  {
    question: "Pick your dream holiday:",
    options: [
      { text: "A festival packed with people", type: "social" },
      { text: "A quiet beach with nothing to do", type: "chill" },
      { text: "Backpacking somewhere new", type: "adventure" },
      { text: "A city break with a packed itinerary", type: "mastermind" },
    ],
  },
  {
    question: "Someone suggests a spontaneous road trip. You say:",
    options: [
      { text: "Yes! Who else is coming?", type: "social" },
      { text: "Maybe, only if it's not too much hassle", type: "chill" },
      { text: "Already packing my bag!", type: "adventure" },
      { text: "Let me check the route and budget first", type: "mastermind" },
    ],
  },
  {
    question: "What's your best trait?",
    options: [
      { text: "I make everyone feel welcome", type: "social" },
      { text: "I never let things stress me out", type: "chill" },
      { text: "I'm always up for anything", type: "adventure" },
      { text: "I always have a plan", type: "mastermind" },
    ],
  },
  {
    question: "Pick a snack:",
    options: [
      { text: "Something to share with the group", type: "social" },
      { text: "Whatever's easiest, no fuss", type: "chill" },
      { text: "Something I've never tried before", type: "adventure" },
      { text: "Whatever gives me the best energy", type: "mastermind" },
    ],
  },
];

const WhichLynxAreYou = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [scores, setScores] = useState({
    social: 0,
    chill: 0,
    adventure: 0,
    mastermind: 0,
  });
  const [result, setResult] = useState(null);

  const handleAnswer = (type) => {
    const newScores = { ...scores, [type]: scores[type] + 1 };
    setScores(newScores);

    if (currentIndex < QUESTIONS.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const winner = Object.keys(newScores).reduce((a, b) =>
        newScores[a] >= newScores[b] ? a : b
      );
      setResult(TYPES[winner]);
    }
  };

  const restart = () => {
    setCurrentIndex(0);
    setScores({ social: 0, chill: 0, adventure: 0, mastermind: 0 });
    setResult(null);
  };

  return (
    <div className="container">
      <br />
      <br />
      <h3 className="text-white">🐾 Which Lynx Are You?</h3>
      <div className="lynx-page-card">
        {!result ? (
          <>
            <p className="text-white text-center">
              Question {currentIndex + 1} of {QUESTIONS.length}
            </p>
            <h5 className="text-lynx fw-bold text-center mb-4">
              {QUESTIONS[currentIndex].question}
            </h5>
            <div className="d-flex flex-column gap-2">
              {QUESTIONS[currentIndex].options.map((option, index) => (
                <button
                  key={index}
                  type="button"
                  className="btn-lynx w-100"
                  onClick={() => handleAnswer(option.type)}
                >
                  {option.text}
                </button>
              ))}
            </div>
          </>
        ) : (
          <div className="text-center">
            <div style={{ fontSize: "4rem" }}>{result.emoji}</div>
            <h4 className="text-lynx fw-bold">{result.title}</h4>
            <p className="smsgpt fs-5 mt-3">{result.desc}</p>
            <button
              type="button"
              className="btn-lynx mt-3"
              onClick={restart}
            >
              🔄 Take it again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhichLynxAreYou;
